import { render, staticRenderFns } from "./LocomotiveLoader.vue?vue&type=template&id=3ff24b54&scoped=true&"
import script from "./LocomotiveLoader.vue?vue&type=script&lang=js&"
export * from "./LocomotiveLoader.vue?vue&type=script&lang=js&"
import style0 from "./LocomotiveLoader.vue?vue&type=style&index=0&id=3ff24b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff24b54",
  null
  
)

export default component.exports